export default __webpack_public_path__ + "static/media/linkedin_cover_company.51a4e6ad.png";